import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { Title } from '@angular/platform-browser';
import { SeoService } from './../../services/seo.service';


@Component({
  selector: 'app-islascoronados',
  templateUrl: './islascoronados.component.html',
  styleUrls: ['./islascoronados.component.css']
})
export class IslascoronadosComponent implements OnInit {





  constructor(
    public dialogRef: MatDialogRef<IslascoronadosComponent>, private title: Title, private seo: SeoService
  ) { }

  ngOnInit() {
    const t = 'Sport Fishing Licenses';
    this.title.setTitle(t);

    this.seo.generateTags({
      title: 'sport fishing Licenses, Coronado Islands-sportfishingmx',
      // tslint:disable-next-line: max-line-length
      description: 'If you practice sport fishing in Mexico, the National Aquaculture and Fisheries Commission requires that each person have a valid fishing license',
       slug: 'Sport Fishing Licenses, Coronado Islands'
    });

  }


  cerrarventana() {
    this.dialogRef.close();
  }

}
